export default {
  401: 'Unauthorized',
  400: 'Bad Request',
  403: 'Forbidden',
  404: 'Not Found',
  409: 'Duplicated',
  500: 'Server Error',
} as const;
